// "All-Around 30" palette from https://lospec.com/palette-list/all-around-30
const palette = [
	"rgb(174, 206, 209)",
	"rgb(122, 148, 168)",
	"rgb(77, 94, 118)",
	"rgb(44, 47, 75)",
	"rgb(0, 0, 0)",
	"rgb(47, 19, 80)",
	"rgb(113, 31, 133)",
	"rgb(204, 63, 200)",
	"rgb(255, 147, 217)",
	"rgb(255, 255, 255)",
	"rgb(145, 242, 251)",
	"rgb(73, 155, 224)",
	"rgb(44, 78, 167)",
	"rgb(25, 33, 113)",
	"rgb(19, 15, 60)",
	"rgb(35, 48, 90)",
	"rgb(47, 91, 112)",
	"rgb(47, 148, 125)",
	"rgb(53, 213, 75)",
	"rgb(171, 255, 55)",
	"rgb(255, 239, 83)",
	"rgb(243, 162, 20)",
	"rgb(226, 98, 39)",
	"rgb(162, 41, 62)",
	"rgb(91, 26, 58)",
	"rgb(35, 3, 33)",
	"rgb(62, 19, 38)",
	"rgb(139, 60, 60)",
	"rgb(205, 115, 73)",
	"rgb(255, 191, 147)",
];

export const defaultColor = "rgb(0, 0, 0)";

export default palette;
